import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="popup"
export default class extends Controller {
  static targets = ["popup"];

  today = new Date();

  connect() {
    console.log("Popup Controller Connected");

    // Parse dates safely
    const startDate = this.parseDate(this.element.dataset.startDate);
    const endDate = this.parseDate(this.element.dataset.endDate);
    this.popupTarget.classList.add("hidden");
    this.triggerPod(startDate, endDate);
  }

  triggerPod(startDate, endDate) {
    if (!startDate || !endDate) return;

    const inDate = this.checkDate(startDate, endDate);
    if (inDate) {
      this.popupTarget.classList.remove("hidden");
    } 
  }
  
  checkDate(startDate, endDate) {
    const todayOnly = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
    const startOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    return todayOnly >= startOnly && todayOnly <= endOnly;
  }

  parseDate(str) {
    if (!str) return null;

    const [year, month, day] = str.split("-").map(Number);
    if (!year || !month || !day) return null;

    return new Date(year, month - 1, day);
  }

  closePopup(){
    this.popupTarget.classList.add("hidden");
  }
}
